import { getLinkLabel, Link, LinkProps } from '@/app/components/Link'
import { TrackingLocation } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'

interface InlineBannerProps {
  value: {
    link: LinkProps['link'] | null
    bannerTag: string
  }
  tracking: TrackingLocation
  className?: string
}

export function InlineBanner({ value, tracking, className }: InlineBannerProps) {
  const { link, bannerTag } = value

  if (!link || !bannerTag) {
    return null
  }

  return (
    <div
      className={cn(
        'inline-banner flex items-center justify-between py-xs pl-xs pr-m gap-m bg-paved-white rounded-lg shadow-[0_1px_18px_0_rgba(0,0,0,0.04)]',
        className,
      )}
    >
      <span className="inline-flex items-center justify-center px-s py-xs size-button-m leading-[16px] rounded-md font-book bg-paved-blue-700 text-paved-white shadow-button">
        {bannerTag}
      </span>
      <Link link={link} tracking={tracking} className="!m-0 size-body-xs text-left">
        {getLinkLabel(link)}
      </Link>
    </div>
  )
}
